<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-text-field
          v-model="signatureTag"
          v-show="!hiddenField(access)"
          :id="id"
          :label="label"
          :type="fieldTextType(dataType)"
          :readonly="true"
          :prefix="prefix"
          :suffix="suffix"
          :filled="readonlyField(access) || queryFlag"
          :rules="rules"
          :outlined="queryFlag"
          :hide-details="queryFlag"
          :dense="queryFlag"
          :hint="hint"
          :single-line="queryFlag"
          :prepend-inner-icon="prependInnerIcon()"
          @click:prepend-inner="clearSignature"
          @input="() => handleChange(null)"
        >
        </v-text-field>
        <canvas
          v-show="!hiddenField(access) && !readonlyField(access)"
          class="signature-pad"
          ref="canvasRef"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SignaturePad from "signature_pad";
export default {
  name: "SignatureField",
  props: [
    "label",
    "value",
    "access",
    "dataType",
    "id",
    "name",
    "prefix",
    "suffix",
    "rules",
    "length",
    "secLength",
    "queryFlag",
    "coordinates",
    "hint",
    "index",
  ],
  data() {
    return {
      defaultValue: this.value,
      currentValue: this.value,
      url: this.value,
      signatureTag: this.value ? " " : null,
      rawFileUrl: null,
      file: this.emptyString(this.value) ? null : {},
      buffer: null,
    };
  },
  components: {
    //SignaturePad,
  },
  methods: {
    handleChange() {
      fetch(this.rawFileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const fileName =
            "signature" +
            this.id +
            "." +
            (blob.type.includes("/") ? blob.type.split("/")[1] : blob.type);
          this.file = new File([blob], fileName, blob);
          this.buffer = this.rawFileUrl.split(",")[1];
          const data = {
            value: this.currentValue,
            id: this.id,
            file: this.file,
            selected: true,
            progress: 0,
            uploaded: false,
            buffer: this.buffer,
          };
          this.$emit("field-change", data);
        });
    },

    setValue(value, autoSource) {
      this.rawFileUrl = value;
      this.handleChange(autoSource);
    },

    prependInnerIcon() {
      if (this.hiddenField(this.access) || this.readonlyField(this.access)) {
        return this.currentValue ? "mdi-check-circle-outline" : null;
      } else {
        return this.rawFileUrl ? "mdi-eraser" : "mdi-draw";
      }
    },

    clearSignature() {
      if (!(this.hiddenField(this.access) || this.readonlyField(this.access))) {
        this.signaturePad.clear();
        this.file = null;
        this.signatureTag = null;
      }
    },
    updateSignature() {
      this.rawFileUrl = !this.signaturePad.isEmpty()
        ? this.signaturePad.toDataURL()
        : null;
      this.signatureTag = " ";
      this.handleChange();
    },
  },
  updated() {},
  mounted() {
    const canvas = this.$refs.canvasRef;
    this.signaturePad = new SignaturePad(canvas);
    this.signaturePad.onEnd = this.updateSignature;
  },
};
</script>

<style scoped>
.signature-pad {
  border: solid 2px rgb(200, 200, 200);
}
</style>